var houseModel = [{
        'name': '图书馆南',
        'coordinate': [
            [114.391733, 30.486417],
            [114.391497, 30.486417],
            [114.391502, 30.486588],
            [114.391637, 30.486583],
            [114.391637, 30.486657],
            [114.391749, 30.486657]
        ],
    },
    {
        'name': '图书馆南',
        'coordinate': [
            [114.392264, 30.486486],
            [114.391776, 30.486486],
            [114.391776, 30.48662],
            [114.391878, 30.48662],
            [114.391878, 30.486671],
            [114.392007, 30.486671],
            [114.392007, 30.486722],
            [114.392388, 30.486717],
            [114.392382, 30.486592],
            [114.39227, 30.486592]
        ],
    },
    {
        'name': '管理学院',
        'coordinate': [
            [114.392725, 30.486477],
            [114.392731, 30.486662],
            [114.392774, 30.486662],
            [114.392774, 30.486722],
            [114.393434, 30.486726],
            [114.393434, 30.486657],
            [114.39353, 30.486657],
            [114.393525, 30.486606],
            [114.393573, 30.486606],
            [114.393568, 30.486504],
            [114.393471, 30.4865],
            [114.393471, 30.486477],
            [114.393257, 30.486477],
            [114.393257, 30.486449],
            [114.392999, 30.486449],
            [114.39301, 30.486477]
        ],
    },
    {
        'name': '民族学与社会学学院',
        'coordinate': [
            [114.392742, 30.486403],
            [114.392747, 30.486269],
            [114.393455, 30.486273],
            [114.393444, 30.486352],
            [114.392903, 30.486356],
            [114.392908, 30.486403]
        ],
    },
    {
        'name': '7号教学楼',
        'coordinate': [
            [114.394295, 30.484161],
            [114.393742, 30.484174],
            [114.393742, 30.484258],
            [114.392948, 30.484248],
            [114.392954, 30.484466],
            [114.393335, 30.484461],
            [114.393335, 30.484382],
            [114.39363, 30.484378],
            [114.39363, 30.484447],
            [114.393764, 30.484443],
            [114.393764, 30.484429],
            [114.394289, 30.484419]
        ],
    },
    {
        'name': '大学食堂',
        'coordinate': [
            [114.395373, 30.484151],
            [114.395196, 30.484151],
            [114.395201, 30.484225],
            [114.394713, 30.48423],
            [114.394719, 30.484299],
            [114.394633, 30.484299],
            [114.394644, 30.484526],
            [114.394778, 30.484526],
            [114.394767, 30.484355],
            [114.395201, 30.484345],
            [114.395201, 30.484549],
            [114.395389, 30.484544]
        ],
    },
    {
        'name': '四号教学楼东',
        'coordinate': [
            [114.395121, 30.486144],
            [114.39511, 30.486019],
            [114.395561, 30.486014],
            [114.395572, 30.486135]
        ],
    },
    {
        'name': '四号教学楼东',
        'coordinate': [
            [114.395277, 30.487087],
            [114.395277, 30.486643],
            [114.395598, 30.486643],
            [114.395598, 30.487082]
        ],
    },
    {
        'name': '四号教学楼',
        'coordinate': [
            [114.394493, 30.487101],
            [114.394998, 30.487101],
            [114.394998, 30.487022],
            [114.395116, 30.487022],
            [114.395089, 30.486569],
            [114.394681, 30.486583]
        ],
    },
    {
        'name': '音乐舞蹈教学排练楼',
        'coordinate': [
            [114.394778, 30.490891],
            [114.394574, 30.490281],
            [114.395234, 30.490133],
            [114.395427, 30.490771]
        ]
    },
    {
        'name': '体育馆',
        'coordinate': [
            [114.393555, 30.483338],
            [114.393565, 30.482866],
            [114.394386, 30.482848],
            [114.394391, 30.483328]
        ]
    },
    {
        'name': '体育馆西面',
        'coordinate': [
             [114.392315, 30.483083],
            [114.392315, 30.482806],
            [114.393179, 30.482806],
            [114.393168, 30.483083]
        ]
    },
    {
        'name': '学生宿舍4栋',
        'coordinate': [
            [114.394681, 30.482519],
            [114.394681, 30.482344],
            [114.395395, 30.482334],
            [114.3954, 30.48251]
        ]
    },
    {
        'name': '学生宿舍3栋',
        'coordinate': [
            [114.393651, 30.48251],
            [114.394332, 30.48251],
            [114.394322, 30.482381],
            [114.393662, 30.482381]
        ]
    },
    {
        'name': '学生宿舍2栋',
        'coordinate': [
            [114.392932, 30.48251],
            [114.393426, 30.482501],
            [114.393426, 30.482381],
            [114.392938, 30.48239]
        ]
    },
    {
        'name': '学生宿舍1栋',
        'coordinate': [
            [114.39216, 30.482621],
            [114.392744, 30.482612],
            [114.392734, 30.482445],
            [114.392154, 30.482464]
        ]
    },
    {
        'name': '学生1食堂',
        'coordinate': [
            [114.391178, 30.48288],
            [114.391913, 30.482871],
            [114.391816, 30.482441],
            [114.391076, 30.482418]
        ]
    },
    {
        'name': '实训楼',
        'coordinate': [
            [114.3904, 30.483319],
            [114.390937, 30.483328],
            [114.390921, 30.483102],
            [114.390765, 30.483102],
            [114.390744, 30.483185],
            [114.39039, 30.483208]
        ]
    },
    {
        'name': '学生宿舍12栋北',
        'coordinate': [
            [114.390304, 30.482825],
            [114.390304, 30.482644],
            [114.390931, 30.48264],
            [114.390931, 30.482834]
        ]
    },
    {
        'name': '学生宿舍12栋',
        'coordinate': [
            [114.390314, 30.482529],
            [114.390314, 30.482371],
            [114.390878, 30.482367],
            [114.390883, 30.482519]
        ]
    },

    {
        'name': '学生宿舍13栋',
        'coordinate': [
            [114.390314, 30.482224],
            [114.390314, 30.482016],
            [114.390803, 30.482016],
            [114.390803, 30.482224]
        ]
    },
    {
        'name': '吴泽霖',
        'coordinate': [
            [114.389826, 30.483144],
            [114.389231, 30.482926],
            [114.389558, 30.482543],
            [114.389746, 30.482852],
            [114.390116, 30.482945]
        ]
    },
    {
        'name': '学生宿舍14栋',
        'coordinate': [
            [114.389354, 30.48184],
            [114.389354, 30.48165],
            [114.389875, 30.481636],
            [114.389885, 30.481821]
        ]
    },
    {
        'name': '学生宿舍16栋',
        'coordinate': [
            [114.39017, 30.481807],
            [114.390717, 30.481798],
            [114.390706, 30.481599],
            [114.39017, 30.481609]
        ]
    },
    {
        'name': '学生宿舍17栋',
        'coordinate': [
            [114.38936, 30.481442],
            [114.38936, 30.481211],
            [114.389939, 30.481211],
            [114.389939, 30.481442]
        ]
    },
    {
        'name': '学生宿舍15栋',
        'coordinate': [
            [114.390116, 30.481424],
            [114.390116, 30.481216],
            [114.390738, 30.481206],
            [114.390733, 30.481424]
        ]
    },
    {
        'name': '学生食堂2西',
        'coordinate': [
            [114.390894, 30.481817],
            [114.390894, 30.481253],
            [114.391119, 30.481248],
            [114.391092, 30.481812]
        ]
    },
    {
        'name': '学生食堂2',
        'coordinate': [
            [114.391226, 30.481798],
            [114.391259, 30.481285],
            [114.391908, 30.481267],
            [114.391886, 30.481775]
        ]
    },
    {
        'name': '国际教育学院',
        'coordinate': [
            [114.388979, 30.481026],
            [114.388995, 30.480809],
            [114.389622, 30.48079],
            [114.389617, 30.481017]
        ]
    },
    {
        'name': '学生宿舍18栋',
        'coordinate': [
            [114.390599, 30.481031],
            [114.390604, 30.480772],
            [114.391205, 30.480763],
            [114.391194, 30.481022]
        ]
    },
    {
        'name': '亲民路西',
        'coordinate': [
            [114.38871,  30.481946],
            [114.389161,  30.481946],
            [114.389156,  30.481415],
            [114.388721,  30.481415]
        ]
    }, {
        'name': '国际教育学院南',
        'coordinate': [
            [114.389038,  30.480684],
            [114.389038,  30.480499],
            [114.389601,  30.480485],
            [114.389606,  30.480666]
        ]
    }, {
        'name': '学生宿舍26栋',
        'coordinate': [
            [114.390368,  30.479616],
            [114.39017,  30.479616],
            [114.39018,  30.479325],
            [114.390894,  30.47932],
            [114.390899,  30.479496],
            [114.390373,  30.479501]
        ]
    }, {
        'name': '学生宿舍22栋',
        'coordinate': [
            [114.391602,  30.479565],
            [114.391602,  30.479334],
            [114.391044,  30.479334],
            [114.391044,  30.479565]
        ]
    }, {
        'name': '学生宿舍21栋',
        'coordinate': [
            [114.391082,  30.479958],
            [114.391634,  30.479963],
            [114.391629,  30.47975],
            [114.391082,  30.47975]
        ]
    }, {
        'name': '学生宿舍23栋',
        'coordinate': [
            [114.391806,  30.479538],
            [114.391811,  30.479348],
            [114.392519,  30.47933],
            [114.392519,  30.479533]
        ]
    }, {
        'name': '学生宿舍18栋',
        'coordinate': [
            [114.390577,  30.481031],
            [114.390577,  30.480772],
            [114.391205,  30.480758],
            [114.3912,  30.481022]
        ]
    }, {
        'name': '学生宿舍19栋',
        'coordinate': [
            [114.390593,  30.480619],
            [114.390588,  30.480402],
            [114.391194,  30.480402],
            [114.391189,  30.480615]
        ]
    }, {
        'name': '学生食堂3、4',
        'coordinate': [
            [114.391366,  30.480998],
            [114.391366,  30.480434],
            [114.392069,  30.480421],
            [114.392069,  30.480985]
        ]
    }, {
        'name': '至善路东',
        'coordinate': [
            [114.392224,  30.481035],
            [114.392224,  30.480869],
            [114.392675,  30.48086],
            [114.392675,  30.481026]
        ]
    },{
    'name': "学生宿舍25栋",
    'coordinate': [
        [114.392825, 30.479598],
        [114.393517, 30.479602],
        [114.393517, 30.479367],
        [114.39283, 30.479357]
    ]
}, {
    'name': "学生宿舍27栋",
    'coordinate' : [
        [114.393715, 30.479598],
        [114.394096, 30.479598],
        [114.394091, 30.479713],
        [114.394284, 30.479722],
        [114.394279, 30.47944],
        [114.394043, 30.47944],
        [114.394043, 30.479403],
        [114.393726, 30.479403]
    ]
}, {
    'name': "游泳区",
    'coordinate' : [
        [114.393394, 30.480948],
        [114.393404, 30.480259],
        [114.39386, 30.480263],
        [114.393839, 30.480952]
    ]
},
{
    'name': "清真食堂",
    'coordinate': [
        [114.392283, 30.481479],
        [114.392449, 30.481479],
        [114.392439, 30.481581],
        [114.392669, 30.481581],
        [114.39268, 30.48116],
        [114.392289, 30.481165]
    ]
}, {
    'name': "学生宿舍6栋",
    'coordinate': [
        [114.392079, 30.481946],
        [114.392669, 30.481946],
        [114.392669, 30.481724],
        [114.392085, 30.481724]
    ]
}, {
    'name': "学生宿舍5栋",
    'coordinate': [
        [114.391972, 30.482298],
        [114.391983, 30.482085],
        [114.3926, 30.482066],
        [114.3926, 30.482284]
    ]
}, {
    'name': "学生宿舍7栋",
    'coordinate': [
        [114.392852, 30.482205],
        [114.39319, 30.482205],
        [114.39319, 30.482103],
        [114.393066, 30.482108],
        [114.393072, 30.481835],
        [114.392857, 30.48184]
    ]
}, {
    'name': "学生宿舍8栋",
    'coordinate': [
        [114.393318, 30.482219],
        [114.393887, 30.482219],
        [114.393882, 30.481983],
        [114.393329, 30.481983]
    ]
}, {
    'name': "学生宿舍9、10栋",
    'coordinate': [
        [114.394, 30.482089],
        [114.394, 30.481909],
        [114.394434, 30.481909],
        [114.394434, 30.481821],
        [114.395319, 30.481803],
        [114.395341, 30.4822],
        [114.394429, 30.48221],
        [114.394424, 30.48208]
    ]
}




]

export default houseModel;



// WEBPACK FOOTER //
// ./src/views/web/MapDate.js